import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import { Card, Col, Row } from "react-bootstrap";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import { ItemShow } from "../../components/form";
import toast from "react-hot-toast";
import { privateApi } from "../../api";

const BrandShow = () => {
      const { brandId } = useParams();
      const [brand, setBrand] = useState([]);

      const loadData = async () => {
            await privateApi
                  .get(`/dashboard/brands/${brandId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setBrand(response.data.brand);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
      };

      useEffect(() => {
            loadData();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Brand Details">
                                          <LinkButton
                                                link="/dashboard/brands"
                                                title="Back"
                                          />
                                    </CardHeader>
                                    <Card.Body>
                                          <Row>
                                                <Col lg={4}>
                                                      <Card>
                                                            <Card.Body className="text-center">
                                                                  <img
                                                                        src={`${brand.image}`}
                                                                        className="w-100"
                                                                  />
                                                            </Card.Body>
                                                      </Card>
                                                </Col>
                                                <Col lg="8">
                                                      <ListGroup>
                                                            <ItemShow
                                                                  title="Title"
                                                                  value={
                                                                        brand.title
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Date"
                                                                  value={
                                                                        brand.date
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="User Name"
                                                                  value={
                                                                        brand.user_name
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Status"
                                                                  value={
                                                                        brand.status ? (
                                                                              <>
                                                                                    <span className="text-success">
                                                                                          Active
                                                                                    </span>
                                                                              </>
                                                                        ) : (
                                                                              <>
                                                                                    <span className="text-warning">
                                                                                          Disable
                                                                                    </span>
                                                                              </>
                                                                        )
                                                                  }
                                                            />
                                                      </ListGroup>
                                                </Col>
                                          </Row>
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default BrandShow;
